import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { RegistrationAdminService } from '../../shared/services/registration-admin.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-deacitvate-agent',
  templateUrl: './deacitvate-agent.component.html',
  styleUrls: ['./deacitvate-agent.component.css']
})
export class DeacitvateAgentComponent implements OnInit {
  agentId: string;
  showRequest = false;
  isErrorMessage: boolean =false;
  constructor(private globalSrv: GlobalServices, private alertService: AlertService,
    private adminSrv: RegistrationAdminService,
    private translate: TranslateService,
    private authenticationService: AuthenticationService, private route: ActivatedRoute,) {
      
      this.agentId =this.route.snapshot.params.Id;
 
    if (this.agentId) {
      this.deActivateAgent(this.agentId);
    }else{
      window.history.back();
    }
  }

  ngOnInit() {
  }
  deActivateAgent(agentId) {
    this.adminSrv.DeActivateAgent(agentId).subscribe(
      d => {
        if (d.Success) {
          this.showRequest = true;
          this.isErrorMessage= false;
        }
        else{
          this.showRequest = true;
          this.isErrorMessage= true;
          //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));
         
        }
      }
    )
  }
}
